module.exports = __webpack_public_path__ + "public/images/patterns.2f2c184cd51b1e434d525bda97cb1f07.png";